import InboxLayout from '@/components/inbox-from-router/_components/inbox-layout';
import { useNotificationsContext } from '@/contexts/notifications-provider';
import useGoToDeal from '@/hooks/use-go-to-deal';
import { HOTKEYS } from '@/lib/hotkeys';
import { createFileRoute } from '@tanstack/react-router';
import { InboxIcon } from 'lucide-react';
import { useHotkeys } from 'react-hotkeys-hook';

export const Route = createFileRoute('/(authenticated)/$hub/inbox/')({
  component: Inbox,
  staticData: {
    keepAlive: true,
  },
});

const DefaultAside = ({
  numberOfUnreadNotifications,
}: {
  numberOfUnreadNotifications: number;
}) => {
  return (
    <div className="flex flex-col gap-2 w-full h-full justify-center items-center m-auto dark:bg-dark">
      <InboxIcon className="size-10"></InboxIcon>
      <div className="w-80 text-wrap text-center">
        You have{' '}
        <span>{numberOfUnreadNotifications} unread notifications.</span> Please
        read them as they help your teammates coordinate. Please keep zero-inbox
        at least once a week.
      </div>
    </div>
  );
};

function Inbox() {
  const { notifications, numberOfUnreadNotifications } =
    useNotificationsContext();
  const { goToDeal } = useGoToDeal();

  // UX NOTE: this is a UX hack that allows users to navigate to the first and last notifications
  // using the keyboard before a notification is loaded into the UI.
  // Once there is a notification, the deal page will handle the navigation.
  useHotkeys(HOTKEYS.INBOX_GO_TO_FIRST_NOTIFICATION, () => {
    const firstNotification = notifications[0];

    if (!firstNotification?.deal?.short_id) return;

    goToDeal({
      dealShortId: firstNotification.deal?.short_id,
      isForInbox: true,
    });
  });

  useHotkeys(HOTKEYS.INBOX_GO_TO_LAST_NOTIFICATION, () => {
    const lastNotification = notifications[notifications.length - 1];

    if (!lastNotification?.deal?.short_id) return;

    goToDeal({
      dealShortId: lastNotification.deal?.short_id,
      isForInbox: true,
    });
  });

  return (
    <div>
      <InboxLayout
        aside={
          <DefaultAside
            numberOfUnreadNotifications={numberOfUnreadNotifications}
          />
        }
      ></InboxLayout>
    </div>
  );
}
